import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
const InfoTag = ({ backgroundColor, color = '#fff', textContent }) => {
    return (_jsx("div", { className: "info-tag", style: { backgroundColor, color }, children: _jsx("span", { children: textContent }) }));
};
export default InfoTag;
